//fires on home design center confirmation page
let purchase = function (ddo) {

	new Image().src = 'https://ad.doubleclick.net/ddm/activity/src=3518820;type=hddc01;cat=hddca0;u1=' + ddo.page.pageInfo.pageName + ';u16=' + _aape.ECID + ';u26=' + document.URL + ';';

};

export {
	purchase
}